import { Box, Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { NAVY } from './styles';

interface Props {
  /** Absent on the first step, where there is nothing to go back to. */
  onBack?: () => void;
  isAdvancing: boolean;
}

/**
 * The single Back control for every node type, so the affordance cannot go
 * missing from one of them or drift out of step with the others.
 *
 * On the first step it renders an empty slot rather than a disabled button: a
 * dead control is noise to someone working a call, and the placeholder keeps
 * Next anchored right instead of sliding across when Back appears on step two.
 *
 * Sized to match the Next button so the two read as a pair, and padded so the
 * label is not flush against the edge of the card.
 */
export function BackButton({ onBack, isAdvancing }: Props) {
  if (!onBack) return <Box />;

  return (
    <Button
      variant="transparent"
      c={NAVY}
      size="md"
      px="md"
      radius="md"
      leftSection={<IconArrowLeft size={16} />}
      disabled={isAdvancing}
      styles={{ root: { fontWeight: 600, '&:hover': { textDecoration: 'underline' } } }}
      onClick={onBack}
    >
      Back
    </Button>
  );
}
